export const sandboxData = {
  blocks: [
    {
      type: 'image',
      props: {
        bottomSpacing: 'large',
        title: 'Commercial Crew',
        titleTextColor: '#FFFFFF',
        averageColor: '#123460',
        imageUrl: 'https://pbs.twimg.com/media/EewDirxUMAA8O_Y.jpg',
      },
    },
    {
      type: 'text',
      props: {
        content:
          'On the afternoon of May 30th, SpaceX is slated to launch its very first passengers to space, potentially heralding a new era of human spaceflight for the United States. It’ll be the first time in nearly a decade that people have launched to orbit from American soil, and it’ll be the first time that a private vehicle takes them there.',
      },
    },
    {
      type: 'list',
      props: {
        topSpacing: 'large',
        bottomSpacing: 'large',
        style: 'vertical',
        data: [
          {
            title: 'New Media Title',
            subtitle: 'New Media Subtitle',
            image: 'https://pbs.twimg.com/media/EewDirxUMAA8O_Y.jpg',
            action: {
              handler: 'browser',
              contentUrl: 'https://www.spacex.com',
              style: 'internal',
            },
          },
          {
            title: 'Media Item 2',
            action: {
              handler: 'browser',
              contentUrl: 'https://www.spacex.com',
              style: 'internal',
            },
          },
          {
            title: 'Media Item 3',
            action: {
              handler: 'browser',
              contentUrl: 'https://www.spacex.com',
              style: 'internal',
            },
          },
          {
            title: 'Media Item 4',
            action: {
              handler: 'browser',
              contentUrl: 'https://www.spacex.com',
              style: 'internal',
            },
          },
        ],
      },
    },
    {
      type: 'text',
      props: {
        h1: true,
        bottomSpacing: 'small',
        content: 'The Launch',
      },
    },
    {
      type: 'text',
      props: {
        content:
          'SpaceX’s Falcon 9 rocket will take off from the company’s launch site at NASA’s Kennedy Space Center in Cape Canaveral, Florida. Known as Launch Complex 39A, it’s seen launches of the Space Shuttle as well as Saturn V rockets that sent humans to the Moon. SpaceX started leasing the complex from NASA in 2014 and transformed the launchpad to support flights of the company’s Falcon 9 and Falcon Heavy rockets.',
      },
    },
    {
      type: 'list',
      props: {
        topSpacing: 'large',
        style: 'horizontal',
        data: [
          {
            title: 'New Media Title',
            subtitle: 'New Media Subtitle',
            image: 'https://pbs.twimg.com/media/EewDirxUMAA8O_Y.jpg',
            action: {
              handler: 'browser',
              contentUrl: 'https://www.spacex.com',
              style: 'internal',
            },
          },
          {
            title: 'Media Item 2',
            action: {
              handler: 'browser',
              contentUrl: 'https://www.spacex.com',
              style: 'internal',
            },
          },
          {
            title: 'Media Item 3',
            action: {
              handler: 'browser',
              contentUrl: 'https://www.spacex.com',
              style: 'internal',
            },
          },
          {
            title: 'Media Item 4',
            action: {
              handler: 'browser',
              contentUrl: 'https://www.spacex.com',
              style: 'internal',
            },
          },
        ],
      },
    },
    {
      type: 'image',
      props: {
        topSpacing: 'large',
        bottomSpacing: 'large',
        imageUrl:
          'https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60',
        averageColor: '#a18b7a',
      },
    },
    {
      type: 'text',
      props: {
        h1: true,
        bottomSpacing: 'small',
        content: 'The Docking',
      },
    },
    {
      type: 'text',
      props: {
        bottomSpacing: 'small',
        content:
          'If all goes as planned, it’s a quick trip to Earth orbit for the two astronauts. The Falcon 9 rocket will release the Crew Dragon into low Earth orbit about 12 minutes after takeoff. The rocket will then return to Earth where it is scheduled to land on a drone ship in the Atlantic Ocean.',
      },
    },
    {
      type: 'button',
      props: {
        title: 'Watch Live',
        topSpacing: 'small',
        bottomSpacing: 'large',
        action: {
          handler: 'browser',
          contentUrl: 'https://www.spacex.com',
          style: 'internal',
        },
      },
    },
  ],
};
